import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import moment from "moment";
import { UserService } from "../../domain/user-service";
import { Logger } from "../../infrastructure/logger";
import { Channel, ChannelInfo } from "../../domain/channel";
import { MediaItem } from "../../domain/media";
import { ChannelRepository } from "../../domain/channel-repository";
import { MediaRepository } from "../../domain/media-repository";
import { ExportPlatformsComponent } from "../export-platforms/export-platforms";
import { ExportConfiguration } from "../../domain/export-configuration";
import { ShowRepository } from "../../domain/show-repository";
import { environment } from "app/environments/environment";
@Component({
  selector: "icn-export-run-log",
  templateUrl: "./export-run-log.html",
  styleUrls: ["./export-run-log.scss"],
})
export class ExportRunLogComponent implements OnInit {
  @ViewChild(ExportPlatformsComponent) exportPlatform: ExportPlatformsComponent;
  endpoint: string;
  startDate: moment.Moment;
  endDate: moment.Moment;
  channelChosen: Channel;
  programChosen: MediaItem;
  channels: Channel[] = [];
  exportAsMarinaXml = false;

  exportConfigurations: ExportConfiguration[];
  exportConfigurationChosen: ExportConfiguration;

  constructor(
    private userService: UserService,
    private logger: Logger,
    private channelRepository: ChannelRepository,
    private mediaRepository: MediaRepository,
    private showRepository: ShowRepository,
    private changeDetectorRef: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.endpoint = environment.ENDPOINT + "/api/";
    this.channelRepository.getTenantChannels().then((channels) => {
      this.channels = channels.filter((c) => !c.isBlock);
    });
    this.showRepository.getExportConfigurations().then((response) => {
      this.exportConfigurations = response;
      if (this.exportConfigurations.length > 0) {
        this.exportConfigurationChosen = this.exportConfigurations[0];
      }
    });
  }

  exportRunLog() {
    if (this.startDate && this.endDate && this.channelChosen) {
      this.showRepository
        .exportRunLog(
          this.channelChosen.id,
          this.startDate,
          this.endDate,
          this.channelChosen.name,
          this.exportConfigurationChosen.id,
          this.exportAsMarinaXml,
        )
        .catch((err) => {
          this.logger.error("Could not export run log. Error: " + err);
        });
    }
  }

  changeStartDate(val) {
    this.startDate = val;
  }

  changeEndDate(val) {
    this.endDate = val;
  }

  onChannelChosenChanged(val) {
    this.channelChosen = val;
  }
  onProgramChosenChanged(val) {
    this.programChosen = val;
  }

  onClickAddPlatform(values, platformsPopover) {
    this.exportPlatform.exportConfiguration = new ExportConfiguration(
      undefined,
      undefined,
      [],
    );
    this.exportPlatform.addOrEdit = "Add";
    platformsPopover.toggle(values);
  }

  onPlatformsClose(platformsPopover) {
    platformsPopover.hide();
  }

  onSelectedExportConfigurationChange(val, platformsPopover) {
    this.exportConfigurationChosen = val;

    this.exportPlatform.exportConfiguration = new ExportConfiguration(
      val.id,
      val.name,
      val.headers.slice(0),
    );
    this.exportPlatform.addOrEdit = "Edit";

    platformsPopover.show(val);
  }

  onAddedExportConfiguration(
    exportConfiguration: ExportConfiguration,
    platformsPopover,
  ) {
    this.exportConfigurationChosen = exportConfiguration;
    this.exportConfigurations.push(exportConfiguration);
    platformsPopover.hide();
    this.changeDetectorRef.markForCheck();
  }

  onUpdatedExportConfiguration(
    exportConfiguration: ExportConfiguration,
    platformsPopover,
  ) {
    const index = this.exportConfigurations.findIndex(
      (x) => x.id === exportConfiguration.id,
    );
    this.exportConfigurations.splice(index, 1, exportConfiguration);
    this.exportConfigurations = this.exportConfigurations.slice(0);
    this.exportConfigurationChosen = exportConfiguration;
    platformsPopover.hide();
    this.changeDetectorRef.markForCheck();
  }

  onExportAsMarinaXmlChecked(state: boolean) {
    this.exportAsMarinaXml = state;
  }
}
